<template>
    <div class="modal-backdrop">
        <div class="modal-content">
            <div class="wrapper w-100">
                <div class="flex-column align-center confirm-loading w-100 max-w-540">
                    <div class="flex-column align-center">
                        <img src="https://static.toss.im/lotties/loading-spot-apng.png" width="120" height="120" />
                        <h2 class="title text-center">결제 요청까지 성공했어요.</h2>
                        <h4 class="text-center description">승인 요청 중입니다. 조금만 기다려주세요.</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-console */

    import { accountApi } from '../../api/api';



    export default {
        data() {
            return {
                token: null,
                payerID: null,
                memberIdx: 1, // 로그인 구현 시 제거
                paymentInfo: {
                    paymentName: null,
                    payerName: null,
                    payerEmail: null,
                    amount: null,
                    currencyCode: null,
                },
            };
        },
        methods: {
            /**
             * 앱 서버에 결제 승인을 요청하는 메서드
             */
            async confirmPayment() {
                const params = {
                    "order_id": this.token,
                }

                accountApi.requestCapturePaypalPayment(params).then((response) => {
                    if (response && response.status === 200) {
                        const responseBody = response.data;

                        this.paymentName = responseBody.payment_name;
                        this.payerName = responseBody.payer_name;
                        this.payerEmail = responseBody.payer_email;
                        this.amount = responseBody.amount;
                        this.currencyCode = responseBody.currency_code;

                        this.toPaymentCompleted();
                    } else {
                        // console.error('결제 승인에 실패했습니다.');
                    }
                });
            },

            /**
             * 쿼리 파라미터 파싱 메서드
             */
            parseQueryParams() {
                const urlParams = new URLSearchParams(window.location.search);
                this.token = urlParams.get("token");
                this.payerID = urlParams.get("PayerID");
            },

            /**
             * 쿼리 파라미터 제거 메서드
             */
            removeQueryParams() {
                const baseUrl = window.location.href.split('?')[0];
                window.history.replaceState(null, null, baseUrl);
            },

            /**
             * 결제 이력 조회 페이지로 리다이렉트하는 메서드
             */
            toPaymentCompleted() {
                this.$router.replace({
                    path: "/payments/paypal/completed",
                    query: {
                        orderId: this.orderId,
                        paymentName: this.paymentName,
                        payerName: this.payerName,
                        payerEmail: this.payerEmail,
                        amount: this.amount,
                        currencyCode: this.currencyCode,
                    },
                });
            },
        },

        /**
         * 1. 쿼리 파라미터 파싱
         * 2. 쿼리 파라미터가 노출되지 않도록 제거
         */
        mounted() {
            this.parseQueryParams();
            this.removeQueryParams();
            this.confirmPayment();
        },
    };
</script>

<style scoped>

    /* ****************** layout ****************** */
    .w-100 {
        width: 100%;
    }

    .wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px;
        overflow: auto;
    }

    .max-w-540 {
        max-width: 540px;
    }

    .text-center {
        text-align: center;
    }

    .flex-column {
        display: flex;
        flex-direction: column;
    }

    .align-center {
        align-items: center;
    }

    .confirm-loading {
        margin-top: 72px;
        height: 400px;
        justify-content: space-between;
    }

    /* ****************** font ****************** */

    .title {
        margin-top: 32px;
        margin-bottom: 0;
        color: #191f28;
        font-weight: bold;
        font-size: 24px;
    }

    .description {
        margin-top: 8px;
        color: #4e5968;
        font-size: 17px;
        font-weight: 500;
    }

    .color-grey {
        color: #b0b8c1;
    }

    /* ****************** modal ****************** */

    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
    }

    .modal-content {
        background-color: white;
        border-radius: 8px;
        min-width: 550px;
        max-width: 600px;
        min-height: 30%;
        max-height: 40%;
        overflow-y: hidden;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
</style>